<template>
  <div class="add-music">
    <music-uploader ref="uploader" :max-files="5" @uploadFile="uploadFile" />
    <div class="mt-4" v-if="files.length">
      <draggable v-model="files" handle=".handle" :animation="200">
        <div
          class="file-info handle"
          v-for="(file, index) in files"
          :key="file.audioSrc"
          style="cursor: move"
        >
          <div class="aplayer">
            <img :src="file.imageSrc" alt="" srcset="" />
            <p
              class="musicstart"
              v-if="!file.isPlay"
              @click="audioPlay(true, index, file.audioSrc)"
            >
              <img src="@/assets/game/start.png" alt="" />
            </p>
            <p
              class="musicstop"
              v-if="file.isPlay"
              @click="audioPlay(false, index, file.audioSrc)"
            >
              <img src="@/assets/game/stop.png" alt="" />
            </p>
          </div>
          <div class="music-info">
            <p class="music-title">
              {{ file.meta.common.title || "未知" }}-{{
                file.meta.common.artist || "未知"
              }}
            </p>
            <p class="music-time">
              <span>时长：</span>
              {{
                file.meta.format.duration
                  ? $moment
                      .utc(file.meta.format.duration * 1000)
                      .format("mm:ss")
                  : "未知"
              }}
            </p>
            <p class="music-time">
              <span>文件格式：</span>
              {{ file.format ? file.format : "未知" }}
            </p>
          </div>
          <el-button class="enter-btn" @click="removeFile(index)"
            >删除</el-button
          >
        </div>
      </draggable>
    </div>

    <div class="clear" v-if="files.length">
      <el-button class="clear-btn" @click="clearAll">清空全部</el-button>
    </div>
    <audio
      :src="audioSrc"
      ref="audio"
      @ended="end"
      :autoplay="isauto"
      controls
      style="display: none"
      preload="metadata"
    ></audio>
    <!-- <el-form
      :model="musicForm"
      :rules="musicRules"
      ref="musicForm"
      class="demo-musicForm"
      hide-required-asterisk
      label-position="left"
    >
      <el-form-item label="音乐名称" prop="musicName">
        <el-input
          v-model="musicForm.musicName"
          placeholder="请输入音乐名称"
          class="text-input"
        ></el-input>
      </el-form-item>
      <el-form-item label="音乐封面" prop="musicCover">
        <upload-img
          :fixedNumber="[20, 20]"
          fixedName="1:1"
          accept="image/*"
          tip="推荐图片尺寸宽高比1:1"
          uploadName="上传封面"
          @uploadInfo="uploadInfo"
          :fixedFlag="true"
        />
      </el-form-item>
      <el-form-item label="上传音乐" prop="musicUrl">
        
      </el-form-item>
      <el-form-item label="音乐时长" prop="musicDuration">
        <el-input
          v-model="musicForm.musicDuration"
          placeholder="上传音乐后自动获取"
          disabled
          class="text-input"
        ></el-input>
      </el-form-item>
      <el-form-item label="音乐地址" prop="musicUrl">
        <el-input
          v-model="musicForm.musicUrl"
          disabled
          placeholder="上传音乐后自动获取"
          class="text-input"
          @click="copyUrl"
        ></el-input>
        <span @click="copyUrl" class="copy">复制</span>
      </el-form-item>
      <el-form-item label="MD5" prop="MD5">
        <el-input
          v-model="musicForm.MD5"
          class="text-input"
          :type="isMd5 ? 'text' : 'password'"
          placeholder="上传音乐后自动获取"
          disabled
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-view"
            @click="changeMd5"
          ></i>
        </el-input>
      </el-form-item>
      <el-form-item style="margin-top: 20px">
        <el-button
          type="primary"
          @click="submitForm('musicForm')"
          class="enter-btn save-btn"
          :loading="submitLoading"
          >确认创建</el-button
        >
        <el-button
          @click="resetForm('musicForm')"
          class="cancel-btn calloff-btn"
          >取消</el-button
        >
      </el-form-item>
    </el-form> -->
  </div>
</template>

<script>
import MusicUploader from "@/components/MusicUploader";
import draggable from "vuedraggable";
export default {
  components: {
    MusicUploader,
    draggable,
  },
  data() {
    return {
      musicForm: {
        musicName: "",
        musicCover: "",
        musicUrl: "",
        MD5: "",
      },
      musicRules: {
        musicName: [
          { required: true, message: "请输入音乐名称", trigger: "blur" },
        ],
        musicSinger: [
          { required: true, message: "请输入音乐演唱人", trigger: "blur" },
        ],
        musicCover: [
          { required: true, message: "请上传音乐封面", trigger: "change" },
        ],
        musicUrl: [
          { required: true, message: "请上传音乐", trigger: "change" },
        ],
        leftOrRight: [
          { required: true, message: "请选择左右拳", trigger: "change" },
        ],
        hit: [
          { required: true, message: "请输入该节奏点时间", trigger: "blur" },
          {
            required: true,
            validator: this.validator.moreThanZero,
            trigger: "blur",
          },
        ],
        forceValue: [
          {
            required: true,
            message: "请输入需要达到的公斤数",
            trigger: "blur",
          },
          {
            required: true,
            validator: this.validator.moreThanZero,
            trigger: "blur",
          },
        ],
        fraction: [
          {
            required: true,
            message: "请输入该节奏点所得分数",
            trigger: "blur",
          },
          {
            required: true,
            validator: this.validator.moreThanZero,
            trigger: "blur",
          },
        ],
      },
      submitLoading: false,
      files: [],
      audioSrc: "",
      // 当前播放任务
      audio: null,
      contorl: null,
      // 当前播放时刻
      current: 0,
      // 播放总时长
      duration: 0,
      // 是否正在播放
      isPlay: false,
      // 是否自动播放
      isauto: false,
    };
  },
  created() {},
  mounted() {
    this.audio = this.$refs.audio;
    this.contorl = this.$refs.contorl;
  },
  methods: {
    // 获取上传封面
    uploadInfo(info) {
      this.musicForm.musicCover = info;
    },
    // 新建音乐
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          console.log(this[formName]);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      // this.$refs[formName].resetFields();
      this.$router.go(-1);
    },
    uploadFile(value) {
      this.files = value;
      console.log(this.files);
    },
    // 音频相关
    // 音频播放暂停
    audioPlay(status, index, audioSrc) {
      if (status) {
        this.audioSrc = audioSrc;
        this.$nextTick(() => {
          this.audio.play();
        });
        this.isauto = true;
        this.files.map((el, index1) => {
          if (index1 === index) {
            el.isPlay = true;
          } else {
            el.isPlay = false;
          }
        });
      } else {
        this.audio.pause();
        this.files[index].isPlay = status;
        this.files = JSON.parse(JSON.stringify(this.files));
        // console.log(index, this.files, status);
      }
    },
    // 音频结束
    end() {
      this.files.map((el) => {
        el.isPlay = false;
      });
    },
    removeFile(index) {
      this.$refs.uploader.removeFile(index);
    },
    clearAll() {
      this.$refs.uploader.clearAll();
    },
  },
};
</script>
<style lang="scss" scoped>
.add-music {
  position: relative;
  display: flex;
  .clear {
    position: absolute;
    top: 0;
    right: 0;
  }
  .mt-4 {
    width: 0;
    box-sizing: border-box;
    flex: 1;
    margin-left: 30px;
    > div {
      width: 60%;
    }
  }
  .file-info {
    display: flex;
    box-sizing: border-box;
    padding: 16px;
    border-radius: 6px;
    margin-bottom: 20px;
    align-items: center;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.07), 0 1px 5px 0 rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    .aplayer {
      background: #fff;
      position: relative;
      // margin: 5px;
      > img {
        height: 66px;
        height: 66px;
        border-radius: 4px;
      }
      .musicstart {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -16px;
        margin-top: -16px;
        cursor: pointer;
        img {
          width: 32px;
          height: 32px;
        }
      }
      .musicstop {
        position: absolute;
        bottom: 5px;
        right: 5px;
        cursor: pointer;
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
    .music-info {
      width: 0;
      flex: 1;
      margin-left: 10px;
      .music-title {
        font-size: 16px;
        font-weight: bold;
        margin: 5px;
        width: 100%;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .music-time {
        font-size: 12px;
        margin: 8px 5px;
        color: #999;
        span {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
